import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { fetchAnalysisResult } from "../../../api/aiReviewService";
import { AIReview } from '../../../common/models/types';
import { AIReviewEvaluation } from '../../../types/aiReviewTest';
import { evaluationApi } from '../../../services/api/aiReviewTest/evaluationApi';
import { WaitingManager } from '../../../components/organisms/CommonUI/WaitingPopup/WaitingManager';
import AdminAIReviewDetailPopupTemplate from '../../../components/templates/AdminAIReviewDetailPopupTemplate';

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
`;

const AdminAIReviewPopup: React.FC = () => {
  const { reviewId, evaluationId } = useParams<{ reviewId: string; evaluationId?: string }>();
  const [review, setReview] = useState<AIReview | null>(null);
  const [evaluation, setEvaluation] = useState<AIReviewEvaluation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadReview = async () => {
      if (!reviewId) {
        setError('리뷰 ID가 없습니다.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        WaitingManager.show({ message: 'AI 리뷰 정보를 불러오는 중...' });
        
        const response = await fetchAnalysisResult(reviewId);
        
        if (response.error === 0 && response.data) {
          setReview(response.data);
          
          // evaluationId가 있으면 평가 데이터도 로드
          if (evaluationId) {
            const evalResponse = await evaluationApi.findOne(Number(evaluationId));
            if (evalResponse.data.error === 0 && evalResponse.data.data) {
              setEvaluation(evalResponse.data.data);
            }
          }
        } else {
          setError(response.message || '리뷰를 불러올 수 없습니다.');
        }
      } catch (err) {
        console.error('Failed to load review:', err);
        setError('정상적인 접근이 아닙니다.');
      } finally {
        setLoading(false);
        WaitingManager.hide();
      }
    };

    loadReview();
  }, [reviewId, evaluationId]);

  // 팝업 창 타이틀 설정
  useEffect(() => {
    if (review) {
      document.title = `AI Review #${review.id}`;
    }
  }, [review]);

  if (loading) {
    return null; // WaitingManager가 표시됨
  }

  if (error) {
    return <ErrorContainer>{error}</ErrorContainer>;
  }

  if (!review) {
    return <ErrorContainer>리뷰 정보가 없습니다.</ErrorContainer>;
  }

  return <AdminAIReviewDetailPopupTemplate review={review} evaluation={evaluation} />;
};

export default AdminAIReviewPopup;